var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentsName,_vm._b({tag:"component",on:{"animateEnd":_vm.switchComponent,"now":_vm.emitNow,"end":_vm.emitEnd}},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }